import { Injectable } from '@angular/core';

import { Api, User } from '../';

@Injectable()
export class Reviews {

  constructor(public api: Api, public user:User) { }

  get(params?: any) {
    return this.api.get('index.php/asset/reviews/', params);
  }

  save(params?: any) {
    console.log(this.user)
    params.reviewer_id = this.user.data.employee_id;
    return this.api.post('index.php/asset/reviews/', params);
  }

  delete(params?: any) {
    return this.api.post('index.php/asset/reviews/delete', params);
  }

}



// WEBPACK FOOTER //
// ./src/providers/asset/reviews/reviews.ts